import { handlePhoneClick } from '../utils/trackPhoneCall';
import { siteConfig } from '../config/site';
import PageMeta from '../components/PageMeta';

const Privacy = () => {
  return (
    <main className="min-h-screen bg-white">
      <PageMeta
        title="Política de Privacidade"
        description={`Como a ${siteConfig.name} recolhe, utiliza e protege os seus dados pessoais.`}
        path="/politica-de-privacidade"
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Política de Privacidade</h1>
        <p className="text-gray-600 mb-6">
          Valorizamos a sua privacidade. Esta política explica como recolhemos, utilizamos e protegemos os seus dados
          pessoais quando utiliza o nosso website e serviços.
        </p>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-900">Dados que recolhemos</h2>
          <p className="text-gray-600">
            Recolhemos as informações enviadas através do formulário de orçamento (nome, telefone, email, localidade e
            detalhes do serviço). Estes dados são utilizados exclusivamente para contacto e elaboração de orçamento.
          </p>
        </section>

        <section className="space-y-4 mt-8">
          <h2 className="text-xl font-semibold text-gray-900">Base legal e finalidade</h2>
          <p className="text-gray-600">
            Tratamos os seus dados com base no seu consentimento e no interesse legítimo de lhe prestar o serviço
            solicitado.
          </p>
        </section>

        <section className="space-y-4 mt-8">
          <h2 className="text-xl font-semibold text-gray-900">Armazenamento e segurança</h2>
          <p className="text-gray-600">
            Mantemos os dados de forma segura e apenas pelo tempo necessário para cumprir a finalidade de contacto e
            prestação de serviços.
          </p>
        </section>

        <section className="space-y-4 mt-8">
          <h2 className="text-xl font-semibold text-gray-900">Direitos do titular</h2>
          <p className="text-gray-600">
            Pode solicitar acesso, correção ou eliminação dos seus dados a qualquer momento. Para exercer os seus
            direitos, contacte-nos através de <a href={`mailto:${siteConfig.email}`} className="text-blue-600 underline">{siteConfig.email}</a>.
          </p>
        </section>

        <section className="space-y-4 mt-8">
          <h2 className="text-xl font-semibold text-gray-900">Contacto</h2>
          <p className="text-gray-600">
            {siteConfig.name} — Lisboa, Portugal. Telefone: <a href={`tel:${siteConfig.phone}`} onClick={handlePhoneClick} className="text-blue-600 underline">{siteConfig.phoneDisplay}</a>.
          </p>
        </section>
      </div>
    </main>
  );
};

export default Privacy;


